export const routes = {
  home: {
    path: '/',
    name: 'landing-page',
    component: () => import('@/components/pages/LandingPage.vue'),
    meta: { requireAuth: false }
  },
  coaching: {
    path: '/coaching',
    name: 'coaching',
    component: () => import('@/components/pages/CoachingPage.vue'),
    meta: { requireAuth: false }
  },
  contact: {
    path: '/contact',
    name: 'contact',
    component: () => import('@/components/pages/ContactPage.vue'),
    meta: { requireAuth: false }
  },
  meetings: {
    path: '/seances-yoga',
    name: 'meetings',
    component: () => import('@/components/pages/MeetingsPage.vue'),
    meta: { requireAuth: false }
  },
  meetingCancel: {
    path: '/seances-yoga/annuler/:meetingId',
    name: 'meeting-cancel',
    component: () => import('@/components/pages/MeetingCancelPage.vue'),
    meta: { requireAuth: false }
  },
  pageNotFound: {
    path: '/:pathMatch(.*)*',
    name: 'page-not-found',
    component: () => import('@/components/pages/NotFoundPage.vue')
  }
};
